import { downloadHost } from "../constants/api"
import strftime from 'strftime'

export const downloadStationHistoryData = async (type, stn, startDate, endDate) => {
    let start=strftime('%Y-%m-%d', startDate)
    let end=strftime('%Y-%m-%d', endDate)
    let endpoint = `${downloadHost}/station/daily`
    let params = `?stn=${stn}&start=${start}&end=${end}`
    let fullurl = `${endpoint}${params}`
    window.location.href = fullurl
}

export const downloadAreaHistoryDate = async(type, tambon, amphoe, province, startDate, endDate) => {
    let start=strftime('%Y-%m-%d', startDate)
    let end=strftime('%Y-%m-%d', endDate)
    let endpoint = `${downloadHost}/area/daily`
    let params = `?tambon=${tambon}&amphoe=${amphoe}&province=${province}&start=${start}&end=${end}`
    let fullurl = `${endpoint}${params}`
    window.location.href = fullurl
}